export default {
  //api: 'https://0yzyle7nph.execute-api.us-east-1.amazonaws.com/dev/',
  api: 'https://api.illustrationx.com/',
  host: 'https://dri2rz6d42pzi.cloudfront.net/',
  imagebase: 'https://media.illustrationx.com/'
}